import { render, staticRenderFns } from "./InvestigateScreen.vue?vue&type=template&id=03aa4286&scoped=true&"
import script from "./InvestigateScreen.vue?vue&type=script&lang=js&"
export * from "./InvestigateScreen.vue?vue&type=script&lang=js&"
import style0 from "./InvestigateScreen.vue?vue&type=style&index=0&id=03aa4286&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03aa4286",
  null
  
)

export default component.exports